import React from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import css from '../styles/home-contact.css';

const { Component } = React;

class Contact extends Component {
  goToContact() {
    browserHistory.push('/contact');
  }

  render() {
    return (
      <div className="home-contact">
        <div className="home-contact__button-wrapper">
          <button className="home-contact__button button-primary" onClick={this.goToContact.bind(this)}>Contact</button>
        </div>
        <div className="home-contact__info">
          <div>Ben F. Meek, III</div>
          <div><a href="tel:4057244454">405.724.4454</a></div>
          <div><a href="mailto@ben@bfm3law.com">ben@bfm3law.com</a></div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {};
}

let ContactContainer = connect(mapStateToProps, mapDispatchToProps)(Contact);

export { Contact, ContactContainer };



// WEBPACK FOOTER //
// ./app/screens/App/screens/Home/components/home-contact.js